// Mock Products Data for Cartlixs Kids Toys Store

export const products = [
  {
    id: 1,
    name: "Wooden Building Blocks Set",
    price: 34.99,
    originalPrice: 44.99,
    rating: 4.8,
    reviews: 342,
    image: "https://images.unsplash.com/photo-1587654780291-39c9404d746b?w=400&h=400&fit=crop",
    category: "building",
    ageGroup: "3-6",
    brand: "KidsCraft",
    description: "A premium set of 100 colorful wooden building blocks that help develop motor skills and creativity. Made from natural, non-toxic materials safe for children.",
    features: ["100 pieces", "Non-toxic paint", "Smooth edges", "Storage bag included"],
    inStock: true,
    isBestseller: true
  },
  {
    id: 2,
    name: "STEM Robot Building Kit",
    price: 59.99,
    originalPrice: 79.99,
    rating: 4.9,
    reviews: 528,
    image: "https://images.unsplash.com/photo-1535572290543-960a8046f5af?w=400&h=400&fit=crop",
    category: "stem",
    ageGroup: "8-12",
    brand: "TechKids",
    description: "Build and program your own robot with this comprehensive STEM kit. Perfect for introducing kids to coding and engineering concepts.",
    features: ["12 robot designs", "App controlled", "Battery included", "Step-by-step guide"],
    inStock: true,
    isBestseller: true
  },
  {
    id: 3,
    name: "Interactive Learning Tablet",
    price: 45.99,
    originalPrice: 55.99,
    rating: 4.7,
    reviews: 891,
    image: "https://images.unsplash.com/photo-1596461404969-9ae70f2830c1?w=400&h=400&fit=crop",
    category: "educational",
    ageGroup: "3-6",
    brand: "LearnPlay",
    description: "Educational tablet designed for young learners featuring alphabet, numbers, shapes, and music activities.",
    features: ["6 learning modes", "Volume control", "Auto shut-off", "Durable design"],
    inStock: true,
    isBestseller: true
  },
  {
    id: 4,
    name: "Rainbow Stacking Rings",
    price: 19.99,
    originalPrice: 24.99,
    rating: 4.9,
    reviews: 1205,
    image: "https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=400&h=400&fit=crop",
    category: "toddler",
    ageGroup: "1-2",
    brand: "BabyFirst",
    description: "Classic stacking toy with vibrant rainbow colors. Perfect for developing hand-eye coordination and color recognition.",
    features: ["8 colorful rings", "Soft plastic", "Easy to grip", "BPA-free"],
    inStock: true,
    isBestseller: true
  },
  {
    id: 5,
    name: "Remote Control Racing Car",
    price: 39.99,
    originalPrice: 49.99,
    rating: 4.6,
    reviews: 673,
    image: "https://images.unsplash.com/photo-1594787318286-3d835c1d207f?w=400&h=400&fit=crop",
    category: "remote-control",
    ageGroup: "6-12",
    brand: "SpeedRacer",
    description: "High-speed remote control car with LED lights and rechargeable battery. Perfect for outdoor and indoor racing fun.",
    features: ["2.4GHz control", "LED lights", "Rechargeable", "30-min playtime"],
    inStock: true,
    isBestseller: true
  },
  {
    id: 6,
    name: "Creative Art Supply Kit",
    price: 29.99,
    originalPrice: 39.99,
    rating: 4.8,
    reviews: 456,
    image: "https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=400&h=400&fit=crop",
    category: "creative",
    ageGroup: "3-12",
    brand: "ArtKids",
    description: "Complete art supply kit with crayons, markers, colored pencils, paints, and brushes. Unleash your child's creativity!",
    features: ["150+ pieces", "Carrying case", "Non-toxic", "Washable colors"],
    inStock: true,
    isBestseller: true
  },
  {
    id: 7,
    name: "Outdoor Sports Set",
    price: 44.99,
    originalPrice: 59.99,
    rating: 4.5,
    reviews: 289,
    image: "https://images.unsplash.com/photo-1596461404969-9ae70f2830c1?w=400&h=400&fit=crop",
    category: "outdoor",
    ageGroup: "6-12",
    brand: "PlayOutside",
    description: "Get kids active with this outdoor sports set including balls, frisbee, and jump rope. Great for family fun!",
    features: ["5 games in 1", "Durable materials", "Storage bag", "All ages"],
    inStock: true,
    isBestseller: false
  },
  {
    id: 8,
    name: "3D Wooden Puzzle Animal Set",
    price: 24.99,
    originalPrice: 32.99,
    rating: 4.7,
    reviews: 567,
    image: "https://images.unsplash.com/photo-1622617760320-82933d3ae583?w=400&h=400&fit=crop",
    category: "puzzle",
    ageGroup: "3-8",
    brand: "PuzzleMasters",
    description: "Set of 6 wooden 3D animal puzzles that develop problem-solving skills and spatial awareness.",
    features: ["6 animal puzzles", "Natural wood", "Safe paint", "Easy assembly"],
    inStock: true,
    isBestseller: true
  },
  {
    id: 9,
    name: "Magnetic Building Tiles",
    price: 54.99,
    originalPrice: 69.99,
    rating: 4.9,
    reviews: 1089,
    image: "https://images.unsplash.com/photo-1558060370-d644479cb6f7?w=400&h=400&fit=crop",
    category: "building",
    ageGroup: "3-10",
    brand: "MagnaPlay",
    description: "100-piece magnetic tile set for endless building possibilities. Strong magnets and vibrant colors inspire creativity.",
    features: ["100 tiles", "Strong magnets", "Clear colors", "Idea booklet"],
    inStock: true,
    isBestseller: true
  },
  {
    id: 10,
    name: "Plush Teddy Bear",
    price: 22.99,
    originalPrice: 29.99,
    rating: 4.8,
    reviews: 823,
    image: "https://images.unsplash.com/photo-1558637845-c8b7ead71a3e?w=400&h=400&fit=crop",
    category: "toddler",
    ageGroup: "1-6",
    brand: "CuddlePals",
    description: "Super soft and cuddly teddy bear made with premium plush fabric. Perfect companion for bedtime and playtime.",
    features: ["12 inches tall", "Machine washable", "Hypoallergenic", "Safety tested"],
    inStock: true,
    isBestseller: false
  },
  {
    id: 11,
    name: "Science Experiment Kit",
    price: 49.99,
    originalPrice: 64.99,
    rating: 4.6,
    reviews: 445,
    image: "https://images.unsplash.com/photo-1567427017947-545c5f8d16ad?w=400&h=400&fit=crop",
    category: "stem",
    ageGroup: "8-12",
    brand: "ScienceGenius",
    description: "Perform 50+ exciting experiments at home! Learn chemistry, physics, and biology through hands-on activities.",
    features: ["50+ experiments", "Safety goggles", "Guide book", "Parent supervision recommended"],
    inStock: true,
    isBestseller: false
  },
  {
    id: 12,
    name: "Musical Instruments Set",
    price: 32.99,
    originalPrice: 42.99,
    rating: 4.5,
    reviews: 378,
    image: "https://images.unsplash.com/photo-1514649923863-ceaf75b7ec00?w=400&h=400&fit=crop",
    category: "creative",
    ageGroup: "3-8",
    brand: "MiniMozart",
    description: "Introduce kids to music with this 10-piece instrument set including xylophone, tambourine, maracas, and more.",
    features: ["10 instruments", "Storage bag", "Natural wood", "Safe for kids"],
    inStock: true,
    isBestseller: false
  }
];

export const categories = [
  {
    id: "educational",
    name: "Educational Toys",
    description: "Learn while playing with our educational toy collection",
    image: "https://images.unsplash.com/photo-1622617760320-82933d3ae583?w=400&h=400&fit=crop",
    productCount: 24
  },
  {
    id: "stem",
    name: "STEM Toys",
    description: "Science, Technology, Engineering & Math toys",
    image: "https://images.unsplash.com/photo-1535572290543-960a8046f5af?w=400&h=400&fit=crop",
    productCount: 18
  },
  {
    id: "building",
    name: "Building Toys",
    description: "Blocks, bricks, and construction sets",
    image: "https://images.unsplash.com/photo-1587654780291-39c9404d746b?w=400&h=400&fit=crop",
    productCount: 32
  },
  {
    id: "creative",
    name: "Creative Toys",
    description: "Art supplies, crafts, and musical instruments",
    image: "https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=400&h=400&fit=crop",
    productCount: 28
  },
  {
    id: "outdoor",
    name: "Outdoor Toys",
    description: "Active play and outdoor fun",
    image: "https://images.unsplash.com/photo-1596461404969-9ae70f2830c1?w=400&h=400&fit=crop",
    productCount: 15
  },
  {
    id: "toddler",
    name: "Toddler Toys",
    description: "Safe toys for ages 1-3",
    image: "https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=400&h=400&fit=crop",
    productCount: 42
  },
  {
    id: "puzzle",
    name: "Puzzle Toys",
    description: "Puzzles and brain teasers for all ages",
    image: "https://images.unsplash.com/photo-1622617760320-82933d3ae583?w=400&h=400&fit=crop",
    productCount: 21
  },
  {
    id: "remote-control",
    name: "Remote Control Toys",
    description: "RC cars, drones, and robots",
    image: "https://images.unsplash.com/photo-1594787318286-3d835c1d207f?w=400&h=400&fit=crop",
    productCount: 16
  }
];

export const reviews = [
  {
    id: 1,
    name: "Sarah M.",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop",
    rating: 5,
    text: "My kids absolutely love these toys. Great quality and fast shipping! Will definitely order again.",
    location: "California"
  },
  {
    id: 2,
    name: "Michael R.",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    rating: 5,
    text: "Best educational toys we've found. Our 5-year-old has learned so much while having fun!",
    location: "Texas"
  },
  {
    id: 3,
    name: "Jennifer L.",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop",
    rating: 5,
    text: "Safe, durable, and engaging. Every parent should check out Cartlixs!",
    location: "New York"
  },
  {
    id: 4,
    name: "David K.",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop",
    rating: 5,
    text: "The customer service is amazing. They helped me find the perfect gift for my grandson.",
    location: "Florida"
  },
  {
    id: 5,
    name: "Emily T.",
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop",
    rating: 5,
    text: "Ordered for my daughter's birthday. Arrived quickly and she hasn't stopped playing with it!",
    location: "Ohio"
  }
];

export const getProductById = (id) => {
  return products.find(p => p.id === parseInt(id));
};

export const getProductsByCategory = (categoryId) => {
  return products.filter(p => p.category === categoryId);
};

export const getBestsellers = () => {
  return products.filter(p => p.isBestseller);
};

export const getCategoryById = (id) => {
  return categories.find(c => c.id === id);
};
